import { useEffect, useState } from 'react';

import { Building2, MapPin, Shield, UserCheck } from 'lucide-react';

export default function ViewAffiliations() {
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setAccepted(true), 1500);
    return () => clearTimeout(t);
  }, []);

  const REQUESTS = [
    { initials: 'LG', name: 'Lucas Girard', detail: 'Licence #06791234 · Doublette' },
    { initials: 'NF', name: 'Nina Faure', detail: 'Licence à renseigner · Triplette' },
  ];

  const PARTNERS = [
    { initials: 'GA', name: 'Grand Avignon Pétanque', city: 'Avignon, 84' },
    { initials: 'MB', name: 'Boule Lyonnaise Grand-Croix', city: 'Saint-Chamond, 42' },
    { initials: 'PC', name: 'Pétanque Club de Grenoble', city: 'Grenoble, 38' },
  ];

  return (
    <div className='grid md:grid-cols-2 gap-10 items-start demo-view-enter'>
      {/* Left — demandes d'adhésion */}
      <div className='space-y-5'>
        <div className='inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/20 px-3 py-1.5 rounded-full'>
          <UserCheck className='w-3.5 h-3.5 text-emerald-500 dark:text-emerald-400' />
          <span className='text-xs font-bold text-emerald-600 dark:text-emerald-400'>Demandes en attente</span>
        </div>

        <div>
          <h3 className='text-2xl font-black text-slate-900 dark:text-white mb-2'>Gérez les adhésions</h3>
          <p className='text-slate-500 dark:text-slate-400 text-sm leading-relaxed'>
            Les joueurs font leur demande en ligne. Vous validez ou refusez en un clic — une notification email leur est
            envoyée automatiquement.
          </p>
        </div>

        <div className='space-y-3'>
          {REQUESTS.map((req, i) => (
            <div
              key={req.name}
              className={`border rounded-2xl p-4 transition-all duration-500 ${
                i === 0 && accepted
                  ? 'bg-emerald-50 border-emerald-200/60 dark:bg-slate-800/70 dark:border-emerald-500/30'
                  : 'bg-white border-slate-200 dark:bg-slate-800/50 dark:border-slate-700'
              }`}
            >
              <div className='flex items-center gap-3'>
                <div className='w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center font-black text-white text-sm shrink-0'>
                  {req.initials}
                </div>
                <div className='flex-1 min-w-0'>
                  <p className='font-bold text-slate-900 dark:text-white text-sm truncate'>{req.name}</p>
                  <p className='text-xs text-slate-500 dark:text-slate-400 mt-0.5'>{req.detail}</p>
                </div>
                {i === 0 && accepted ? (
                  <span className='bg-emerald-500/10 border border-emerald-500/20 text-emerald-600 dark:text-emerald-400 text-[9px] font-black px-2 py-0.5 rounded-md uppercase tracking-wider shrink-0'>
                    Accepté
                  </span>
                ) : (
                  <div className='flex gap-2 shrink-0'>
                    <button className='text-[10px] font-black bg-emerald-500/10 border border-emerald-500/20 text-emerald-600 dark:text-emerald-400 px-2.5 py-1 rounded-lg'>
                      Valider
                    </button>
                    <button className='text-[10px] font-black bg-red-500/10 border border-red-500/20 text-red-500 dark:text-red-400 px-2.5 py-1 rounded-lg'>
                      Refuser
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className='flex items-start gap-2 text-xs text-slate-500 bg-slate-50 border border-slate-200 dark:bg-slate-900/50 dark:border-slate-800 rounded-xl px-4 py-3'>
          <Shield className='w-3.5 h-3.5 shrink-0 mt-0.5' />
          <span>Les membres du club accèdent aux concours en accès restreint.</span>
        </div>
      </div>

      {/* Right — organisateurs partenaires */}
      <div className='space-y-4'>
        <p className='text-[10px] font-black text-slate-500 uppercase tracking-widest'>Organisateurs partenaires</p>

        <div className='space-y-3'>
          {PARTNERS.map(partner => (
            <div
              key={partner.name}
              className='bg-white border border-slate-200 dark:bg-slate-800/50 dark:border-slate-700 rounded-2xl p-4 flex items-center gap-3 hover:border-blue-300 dark:hover:border-blue-500/40 transition cursor-pointer'
            >
              <div className='w-10 h-10 bg-slate-200 dark:bg-slate-700 rounded-xl flex items-center justify-center font-black text-slate-500 dark:text-slate-400 text-sm shrink-0'>
                <Building2 className='w-5 h-5' />
              </div>
              <div className='flex-1 min-w-0'>
                <p className='font-bold text-slate-900 dark:text-white text-sm truncate'>{partner.name}</p>
                <p className='text-xs text-slate-500 dark:text-slate-400 mt-0.5 flex items-center gap-1'>
                  <MapPin className='w-3 h-3 shrink-0' />
                  {partner.city}
                </p>
              </div>
              <span className='bg-emerald-500/10 border border-emerald-500/20 text-emerald-600 dark:text-emerald-400 text-[9px] font-black px-2 py-0.5 rounded-md uppercase tracking-wider shrink-0'>
                Affilié
              </span>
            </div>
          ))}
        </div>

        <p className='text-center text-slate-500 dark:text-slate-600 text-xs pt-1'>+ autres organisateurs affiliés</p>
      </div>
    </div>
  );
}
